// hooks/useCodeExportCSV.js
import { useCallback } from "react";

const useExportCSV = () => {
  const exportToCSV = useCallback((data, filename = "discount-codes.csv") => {
    if (!data || data.length === 0) {
      console.warn("No data available for export");
      return;
    }

    try {
      const headers = [
        "Code",
        "Program",
        "Status",
        "Usage",
        "Usage Percentage",
        "MRR Impact",
        "Date Created",
        "Creator",
        "Channel",
        "Uses Per Code",
        "Start Date",
        "End Date",
      ];

      // Convert data to CSV rows
      const csvRows = data.map((item) => {
        const totalCodes = item.number_of_code || 0;
        const usedCodes = item.used_codes || 0;
        const usagePercentage =
          totalCodes > 0
            ? Math.round((usedCodes / totalCodes) * 100) + "%"
            : "0%";

        return [
          `"${(item.name || "").replace(/"/g, '""')}"`,
          `"${(item.program?.name || "N/A").replace(/"/g, '""')}"`,
          item.status
            ? item.status.charAt(0).toUpperCase() + item.status.slice(1)
            : "N/A",
          `${usedCodes}/${totalCodes}`,
          usagePercentage,
          item.mrr_impact || "N/A",
          item.createdAt
            ? new Date(item.createdAt).toLocaleDateString()
            : "N/A",
          `"${(item.user?.name || "N/A").replace(/"/g, '""')}"`,
          item.channel || "N/A",
          item.uses_per_code || "N/A",
          item.start_date
            ? new Date(item.start_date).toLocaleDateString()
            : "N/A",
          item.expires_at
            ? new Date(item.expires_at).toLocaleDateString()
            : "N/A",
        ];
      });

      // Combine headers and rows
      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) => row.join(",")),
      ].join("\n");

      // Create and trigger download
      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting CSV:", error);
    }
  }, []);

  const exportAllToCSV = useCallback(
    (data, filename = "all-discount-codes.csv") => {
      exportToCSV(data, filename);
    },
    [exportToCSV]
  );

  return { exportToCSV, exportAllToCSV };
};

export default useExportCSV;
